import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';

import { FloatingOverlay, FloatingPortal } from '@floating-ui/react';

import { zIndex } from '@ecp/common/src/style/constant';
import Loading from '@ecp/common/src/components/progress/bo/Loading';

const LoadingSpinner = () => {
  const { promiseInProgress } = usePromiseTracker({ delay: 500 });

  return (
    <FloatingPortal>
      {promiseInProgress && (
        <FloatingOverlay
          lockScroll
          style={{
            display: 'grid',
            background: 'rgba(25, 25, 25, 0.65)',
            placeItems: 'center',
            zIndex: zIndex.spinner,
          }}
        >
          <Loading />
        </FloatingOverlay>
      )}
    </FloatingPortal>
  );
};

export default LoadingSpinner;
